function truncateTextNode (
  textNode,
  rootElement,
  maximumHeight,
  ellipsisCharacter
) {
  var lastIndexOfWhitespace
  var textContent = textNode.textContent
  while (textContent.length > 1) {
    lastIndexOfWhitespace = textContent.lastIndexOf(' ')
    if (lastIndexOfWhitespace === -1) {
      break
    }
    textNode.textContent = textContent.substring(0, lastIndexOfWhitespace)
    if (rootElement.scrollHeight <= maximumHeight) {
      textNode.textContent = textContent
      break
    }
    textContent = textNode.textContent
  }
  return truncateTextNodeByCharacter(
    textNode,
    rootElement,
    maximumHeight,
    ellipsisCharacter
  )
}

var TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX = /[ .,;!?'‘’“”\-–—]+$/
function truncateTextNodeByCharacter (
  textNode,
  rootElement,
  maximumHeight,
  ellipsisCharacter
) {
  var textContent = textNode.textContent
  var length = textContent.length
  while (length > 1) {
    // Trim off one trailing character and any trailing punctuation and whitespace.
    textContent = textContent
      .substring(0, length - 1)
      .replace(TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX, '')
    length = textContent.length
    textNode.textContent = textContent + ellipsisCharacter
    if (rootElement.scrollHeight <= maximumHeight) {
      return true
    }
  }
  return false
}

function truncateElementNode (
  element,
  rootElement,
  maximumHeight,
  ellipsisCharacter
) {
  var childNodes = element.childNodes
  var i = childNodes.length - 1
  while (i > -1) {
    var childNode = childNodes[i--]
    var nodeType = childNode.nodeType
    if (
      (nodeType === 1 &&
        truncateElementNode(
          childNode,
          rootElement,
          maximumHeight,
          ellipsisCharacter
        )) ||
      (nodeType === 3 &&
        truncateTextNode(
          childNode,
          rootElement,
          maximumHeight,
          ellipsisCharacter
        ))
    ) {
      return true
    }
    element.removeChild(childNode)
  }
  return false
}

var ELLIPSIS_CHARACTER = '\u2026'

function lineClamp(rootElement, lineCount, options) {
  rootElement.style.cssText +=
    'overflow:hidden;overflow-wrap:break-word;word-wrap:break-word'

  var maximumHeight =
    (lineCount || 1) *
    parseInt(window.getComputedStyle(rootElement).lineHeight, 10) + 4 // @todo: IE11 fix

  // Exit if text does not overflow `rootElement`.
  if (rootElement.scrollHeight <= maximumHeight) {
    return
  }

  truncateElementNode(
    rootElement,
    rootElement,
    maximumHeight,
    (options && options.ellipsis) || ELLIPSIS_CHARACTER
  )
}

function setup(el, binding) {
  if (el.__lineClampFn__) return;
  const options = binding.value && typeof binding.value === 'object' ? binding.value : { lines: binding.value };
  if (options.text === undefined) options.text = el.innerHTML;
  let lines = options.lines || 3;
  let retryCount = 0;
  el.__lineClampOriginalContent__ = options.text;
  el.__lineClampFn__ = () => {
    el.innerHTML = el.__lineClampOriginalContent__;
    lineClamp(el, lines);
    retryCount++;

    if (retryCount < 10) {
      const result = (el.innerHTML || '').trim();
      if (!result) {
        setTimeout(() => {
          el.__lineClampFn__ && el.__lineClampFn__();
        }, 250);
      }
    }
  };

  window.addEventListener('resize', el.__lineClampFn__, false);
  window.addEventListener('load', el.__lineClampFn__, false);
}

function reset(el) {
  if (!el.__lineClampFn__) return;
  window.removeEventListener('resize', el.__lineClampFn__, false);
  window.removeEventListener('load', el.__lineClampFn__, false);
  delete el.__lineClampFn__;
  delete el.__lineClampOriginalContent__;
}

export default {
  inserted: (el, binding) => {
    setup(el, binding);
    el.__lineClampFn__();
  },
  componentUpdated: (el, binding) => {
    if (el.__lineClampOriginalContent__ !== el.innerHTML) {
      reset(el);
      setup(el, binding);
      el.__lineClampFn__();
    }
  },
  unbind(el, binding) {
    reset(el, binding);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/directives/line-clamp.js